import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './useAuth';

/** Redirects to /login when there is no active session (SPEC §9 protected routes). */
export function RequireAuth({ children }: { children: ReactElement }): ReactElement {
  const { authenticated, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (!authenticated) return <Navigate to="/login" replace />;
  return children;
}
